export const AttributeListSurface = {
  None: 'none',
  Base: 'base',
  Raised: 'raised',
} as const;

export type AttributeListSurfaceType =
  (typeof AttributeListSurface)[keyof typeof AttributeListSurface];

export type AttributeListColumns = 1 | 2;

export type AttributeListTitleTag = 'h2' | 'h3' | 'h4';

export type AttributeListProps = {
  title?: string;
  titleAs?: AttributeListTitleTag;
  subtitle?: string;
  surface?: AttributeListSurfaceType;
  columns?: AttributeListColumns;
  withDividers?: boolean;
  empty?: boolean;
  emptyText?: string;
  copyable?: boolean;
  copyTitle?: string;
  copyLabel?: string;
  ariaLabel?: string;
  testId?: string;
};

export type AttributeListEmits = {
  copy: [];
};

export type AttributeListSlots = {
  default?: () => unknown;
  leading?: () => unknown;
  title?: () => unknown;
  subtitle?: () => unknown;
  actions?: () => unknown;
  trailing?: () => unknown;
  alert?: () => unknown;
};
